export const MAP_FROM_FILTER_TYPE_TO_REDUX_ATTRIBUTE = {
  CURRENT_SCHEDULE: "selectedFilter",
  SOLVER_OUTPUT: "selectedFilterForSolverOutput"
};
